'use strict';

var angular = require('angular');
var XLSX = require("xlsx");

module.exports = function($scope, $http, $location, ngAudio) {
    $http.get('/api/game/get-chains')
        .then(function(response) {
            $scope.chains = response.data;
        });

    $scope.getStats = function() {
        $scope.accessError = false;
        $scope.otherError = false;

        $http({
            url: '/api/stats/all',
            method: 'POST',
            data: {
                'region': $scope.region,
                'chain': $scope.chain !== undefined && $scope.chain !== null ? $scope.chain.id : '',
                'from': $scope.from,
                'to': $scope.to,
                'password': $scope.password
            }
        })
        .then(function(result) {
            $scope.stats = result.data;
        },
        function(error) {
            if (error.status == 403) {
                $scope.accessError = true;
            }
            else {
                $scope.otherError = true;
            }
        });
    }

    /**
     * Export Html Table To Excel. 
     */
     $scope.downloadExcel = function() {
        var workbook = XLSX.utils.book_new();

        // Overview table
        var worksheet = XLSX.utils.table_to_sheet(document.getElementById('stats-overview'));
        create_gap_rows(worksheet, 2);
        
        // Chain stats
        XLSX.utils.sheet_add_dom(worksheet, document.getElementById('chain-stats'), {origin: -1});
        worksheet["!cols"] = [ { wch: 20 }, { wch: 20 }, { wch: 20 } ];

        XLSX.utils.book_append_sheet(workbook, worksheet, "Statistikk");
        XLSX.writeFile(workbook, "Statistikk.xlsx");
    }

    function create_gap_rows(ws, nrows) {
        var ref = XLSX.utils.decode_range(ws["!ref"]);
        ref.e.r += nrows;
        ws["!ref"] = XLSX.utils.encode_range(ref);
    }
};
